import { CardContent, Typography, useTheme } from "@mui/material";
import {
  PopularLabel,
  PricingButton,
} from "../../components";
import { getCardStyles } from "./styles";
import {PaymentFrequencyEnum} from "@/types/enums.ts";
import {getPricingComponentByName} from "@/components/Subscription/Plans/PlansTable/getRowValues.tsx";

interface IProps {
  plan: IPlan;
  paymentFrequency: PaymentFrequencyEnum;
}

const Pricing: React.FC<IProps> = ({ plan, paymentFrequency }) => {
  const theme = useTheme();
  const { mostPopular, name } = plan;

  return (
    <CardContent sx={getCardStyles(theme, mostPopular)}>
      {mostPopular && <PopularLabel />}
      <Typography
        variant="h4"
        component="h3"
        fontSize={24}
        mb={{ xs: 0.5, md: 2 }}
      >
        {name}
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={{ xs: 2, md: 3 }}>
        Advanced capabilities
      </Typography>
        <Typography pb={{xs:2, md:2}}> {getPricingComponentByName(plan, 'totalPrice', theme, paymentFrequency)}</Typography>

      <PricingButton plan={plan} />
    </CardContent>
  );
};

export default Pricing;
